import React from 'react';
import { Mail, Linkedin, Twitter, Dribbble } from 'lucide-react';
export function Contact() {
  const socialLinks = [{
    icon: <Mail size={24} data-id="element-39" />,
    href: 'mailto:hello@example.com',
    label: 'Email'
  }, {
    icon: <Linkedin size={24} data-id="element-40" />,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: <Twitter size={24} data-id="element-41" />,
    href: '#',
    label: 'Twitter'
  }, {
    icon: <Dribbble size={24} data-id="element-42" />,
    href: '#',
    label: 'Dribbble'
  }];
  return <section id="contact" className="py-32 px-6 md:px-12 bg-card-bg border-t border-border" data-id="element-43">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-44">
        <h2 className="font-serif text-5xl md:text-7xl text-text mb-6" data-id="element-45">
          Let's work together.
        </h2>

        <p className="font-sans text-xl text-text-muted max-w-2xl mb-12 leading-relaxed" data-id="element-46">
          I'm currently available for freelance projects and full-time
          opportunities. Whether you have a project in mind or just want to say
          hi, my inbox is always open.
        </p>

        <a href="mailto:hello@example.com" className="inline-flex items-center justify-center px-8 py-4 bg-accent hover:bg-accent-hover text-white rounded-full font-medium text-lg transition-colors duration-300 shadow-lg shadow-accent/20 mb-16" data-id="element-47">
          Say Hello
        </a>

        <div className="flex items-center justify-center gap-8" data-id="element-48">
          {socialLinks.map(link => <a key={link.label} href={link.href} aria-label={link.label} className="text-text-muted hover:text-accent transition-colors duration-300 transform hover:-translate-y-1" data-id="element-49">
              {link.icon}
            </a>)}
        </div>
      </div>
    </section>;
}